module.exports = __webpack_public_path__ + "img/166.f83da3ca.jpg";